import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  inject,
  PLATFORM_ID,
} from "@angular/core";
import {
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";

import { CommonModule, isPlatformServer } from "@angular/common";

import {
  TuiButton,
  TuiIcon,
  TuiLabel,
  TuiLink,
  TuiTitle,
} from "@taiga-ui/core";
import {
  TuiProgressBar,
  TuiFieldErrorPipe,
  TuiCheckbox,
  TuiFilterByInputPipe,
  TuiFiles,
} from "@taiga-ui/kit";

import {
  TuiError,
  TuiDataList,
  TuiAppearance,
  TuiRoot,
  TuiTextfield,
  TuiDropdown,
} from "@taiga-ui/core";
import {
  TuiDataListWrapper,
  TuiRadio,
  TuiAvatar,
  TuiBadge,
  TuiItemsWithMore,
  TuiProgress,
  TuiBadgedContent,
  TuiTabs,
  TuiInputNumber,
} from "@taiga-ui/kit";

import {
  TuiInputDateModule,
  TuiInputModule,
  TuiInputPhoneModule,
  TuiInputSliderModule,
  TuiInputTimeModule,
  TuiSelectModule,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputTagModule,
  TuiComboBoxModule,
  TuiMultiSelectModule,
  TuiInputDateTimeModule,
  TuiInputNumberModule,
} from "@taiga-ui/legacy";

import { TUI_IS_E2E, TuiDay } from "@taiga-ui/cdk";
import { AsyncPipe } from "@angular/common";
import { of, timer, takeWhile, share, repeat, map } from "rxjs";
import { NG_EVENT_PLUGINS } from "@taiga-ui/event-plugins";
import { Router } from "@angular/router";
import { Meta, Title } from "@angular/platform-browser";
import { ProgramService } from "../../../services/program.service";

@Component({
  selector: 'app-program-complete',
  standalone: true,
    imports: [ReactiveFormsModule,
          CommonModule,
          AsyncPipe,
          TuiProgressBar,
          TuiButton,
          TuiDropdown,
          TuiLabel,
          TuiFieldErrorPipe,
          TuiError,
          TuiDataList,
          TuiAppearance,
          TuiRadio,
          TuiInputDateModule,
          TuiTextfield,
          TuiTextfieldControllerModule,
          TuiInputModule,
          TuiInputNumber,
          TuiInputPhoneModule,
          TuiInputTimeModule,
          TuiSelectModule,
          TuiTextareaModule,
          TuiCheckbox,
          TuiAvatar,
          TuiInputTagModule,
          TuiIcon,
          TuiProgress,
          TuiFilterByInputPipe,
          TuiFiles,
          TuiComboBoxModule,
          TuiMultiSelectModule,
          TuiBadgedContent,
          TuiDataListWrapper,
          TuiInputNumberModule,
          TuiInputSliderModule,
          TuiTextfieldControllerModule,
          TuiItemsWithMore,
          TuiTabs,
          FormsModule,
          TuiTitle,
          TuiInputDateTimeModule,
          TuiLink,
          TuiRoot],
  templateUrl: './program-complete.component.html',
  styleUrl: './program-complete.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [NG_EVENT_PLUGINS],
})
export class ProgramCompleteComponent {
  currentSurveyStep: number = 6;
  currentSurveyInnerStep: number = 1;
  currentSatisfactionStep: number = 1;
  currentStep: number = 1;
  firstPage: number = 1;
  current_upload_inner_step: number = 1;
  currentSeasonSurveyStep: number = 1;
  endOfSeasonSurveyStatus: any;
  applicationLockSatus: any
  satisfactionSurveyStatus: any;
  cleanRowPhotosStatus: any;
 constructor(private router:Router,private meta:Meta,private title:Title,private programService:ProgramService){
     this.title.setTitle("End-of-Season Survey");
     this.meta.updateTag({ name: 'description', content: '' })
     this.applicationLockSatus = sessionStorage.getItem("applicationLockSatus");
     this.satisfactionSurveyStatus = sessionStorage.getItem("satisfactionSurveyStatus");
     this.cleanRowPhotosStatus = sessionStorage.getItem("cleanRowPhotosStatus");
     this.endOfSeasonSurveyStatus = sessionStorage.getItem("endOfSeasonSurveyStatus");
     if(this.endOfSeasonSurveyStatus == 'COMPLETED' && this.cleanRowPhotosStatus == 'COMPLETED' && this.satisfactionSurveyStatus == 'COMPLETED' && this.applicationLockSatus == 'COMPLETED'){
      // this.currentStep = 6;
    }else{
      this.router.navigate(['/program'])
    }
   }
   ngAfterViewInit() {
    setTimeout(() => {
      document.querySelector('#programComplete')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },600);
  }
  returnToMainDashboard() {
    this.currentSurveyStep = 1;
    this.currentStep = 1;
    this.firstPage = 1;
    this.router.navigate(['/program']);
  }
  downloadImage(imageUrl: string, imageName: string) {
    window.open(imageUrl,"_blank");
  }
}
